// extracted by mini-css-extract-plugin
module.exports = {"CutList":"CutList_CutList__3fKwK","CutListHeader":"CutList_CutListHeader__2x7uZ","CutListDisplay":"CutList_CutListDisplay__1SWaA"};